import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';

export function AdminUpdates() {
 const [rows, setRows] = useState([]);
 const [form, setForm] = useState({ title: '', body: '', image_base64: '', published: true });
 const load = async () => { const { data } = await api.get('/admin/updates'); setRows(data.updates || []); };
 useEffect(() => { load(); }, []);
 const onFile = (e) => {
 const f = e.target.files?.[0]; if (!f) return;
 if (f.size > 2_000_000) { alert('Max 2MB'); return; }
 const r = new FileReader(); r.onload = () => setForm(s => ({ ...s, image_base64: r.result })); r.readAsDataURL(f);
 };
 const add = async (e) => { e.preventDefault(); await api.post('/admin/updates', form); setForm({ title: '', body: '', image_base64: '', published: true }); load(); };
 const del = async (id) => { await api.delete(`/admin/updates/${id}`); load(); };
 return (
 <div className="space-y-6">
 <Panel className="p-6">
 <div className="h-eyebrow mb-3">New Founder Update</div>
 <form onSubmit={add} className="space-y-3">
 <input className="h-input" required placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
 <textarea className="h-input" rows={4} required placeholder="Body" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} />
 <input type="file" accept="image/*" onChange={onFile} className="text-sm" />
 <label className="flex items-center gap-2 text-sm" style={{ color: 'var(--heritage-plum)' }}>
 <input type="checkbox" checked={form.published} onChange={(e) => setForm({ ...form, published: e.target.checked })} /> Published
 </label>
 <button className="h-btn">Publish</button>
 </form>
 </Panel>
 <div className="grid md:grid-cols-2 gap-3">
 {rows.map(r => (
 <Panel key={r.id} className="p-4">
 <div className="h-eyebrow">{(r.created_at || '').slice(0,10)} {r.published ? '' : '• Draft'}</div>
 <div className="h-serif text-lg" style={{ color: 'var(--heritage-plum)' }}>{r.title}</div>
 <div className="text-sm mt-1 opacity-80" style={{ color: 'var(--heritage-plum)' }}>{r.body}</div>
 <button className="h-btn-outline text-xs mt-2" onClick={() => del(r.id)}>Delete</button>
 </Panel>
 ))}
 </div>
 </div>
 );
}

export function AdminPitches() {
 const [rows, setRows] = useState([]);
 const load = async () => { const { data } = await api.get('/admin/pitches'); setRows(data.pitches || []); };
 useEffect(() => { load(); }, []);
 const decide = async (id, approved) => { await api.post(`/admin/pitches/${id}/decision`, { approved }); load(); };
 return (
 <div className="grid md:grid-cols-2 gap-3">
 {rows.map(r => (
 <Panel key={r.id} className="p-4">
 <div className="flex justify-between">
 <div>
 <div className="h-serif text-lg" style={{ color: 'var(--heritage-plum)' }}>{r.title}</div>
 <div className="h-eyebrow">by {r.user_name} • {r.votes} votes • {r.status}</div>
 </div>
 <div className="flex gap-2">
 <button className="h-btn text-xs" onClick={() => decide(r.id, true)}>Approve</button>
 <button className="h-btn-outline text-xs" onClick={() => decide(r.id, false)}>Reject</button>
 </div>
 </div>
 <p className="text-sm mt-2 opacity-80" style={{ color: 'var(--heritage-plum)' }}>{r.description}</p>
 </Panel>
 ))}
 {rows.length === 0 && <div className="text-sm opacity-70" style={{ color: 'var(--heritage-plum)' }}>No pitches yet.</div>}
 </div>
 );
}

export function AdminDiscountCodes() {
 const [rows, setRows] = useState([]);
 const [form, setForm] = useState({ code: '', percent: 10, active: true });
 const load = async () => { const { data } = await api.get('/admin/discount-codes'); setRows(data.codes || []); };
 useEffect(() => { load(); }, []);
 const add = async (e) => { e.preventDefault(); await api.post('/admin/discount-codes', form); setForm({ code: '', percent: 10, active: true }); load(); };
 const del = async (id) => { await api.delete(`/admin/discount-codes/${id}`); load(); };
 return (
 <div className="space-y-6">
 <Panel className="p-6">
 <div className="h-eyebrow mb-3">Create discount code</div>
 <form onSubmit={add} className="grid md:grid-cols-4 gap-3">
 <input className="h-input" required placeholder="Code" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} />
 <input className="h-input" required type="number" min="0" max="100" value={form.percent} onChange={(e) => setForm({ ...form, percent: parseInt(e.target.value) })} />
 <label className="flex items-center gap-2 text-sm" style={{ color: 'var(--heritage-plum)' }}><input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} /> Active</label>
 <button className="h-btn">Add</button>
 </form>
 </Panel>
 <div className="grid md:grid-cols-3 gap-3">
 {rows.map(r => (
 <Panel key={r.id} className="p-4 flex items-center justify-between">
 <div>
 <div className="h-serif text-lg" style={{ color: 'var(--heritage-plum)' }}>{r.code}</div>
 <div className="h-eyebrow">{r.percent}% • {r.active ? 'Active' : 'Inactive'}</div>
 </div>
 <button className="h-btn-outline text-xs" onClick={() => del(r.id)}>Delete</button>
 </Panel>
 ))}
 </div>
 </div>
 );
}

export function AdminContent() {
 const [rows, setRows] = useState([]);
 const [form, setForm] = useState({ key: '', value: '' });
 const load = async () => { const { data } = await api.get('/admin/site-content'); setRows(data.content || []); };
 useEffect(() => { load(); }, []);
 const save = async (e) => { e.preventDefault(); await api.post('/admin/site-content', form); setForm({ key: '', value: '' }); load(); };
 const edit = (r) => setForm({ key: r.key, value: r.value });
 return (
 <div className="space-y-6">
 <Panel className="p-6">
 <div className="h-eyebrow mb-3">Website content (key/value)</div>
 <form onSubmit={save} className="grid md:grid-cols-3 gap-3">
 <input className="h-input" required placeholder="key (e.g. hero_headline)" value={form.key} onChange={(e) => setForm({ ...form, key: e.target.value })} />
 <input className="h-input md:col-span-2" required placeholder="value" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} />
 <button className="h-btn md:col-span-3">Save</button>
 </form>
 </Panel>
 <Panel className="p-6">
 <table className="w-full text-sm">
 <thead><tr className="text-left h-eyebrow"><th className="py-2">Key</th><th>Value</th><th></th></tr></thead>
 <tbody style={{ color: 'var(--heritage-plum)' }}>
 {rows.map(r => (
 <tr key={r.key} className="border-t" style={{ borderColor: 'rgba(75,24,56,0.1)' }}>
 <td className="py-2 h-serif">{r.key}</td><td className="break-all">{String(r.value)}</td>
 <td><button className="h-btn-outline text-xs" onClick={() => edit(r)}>Edit</button></td>
 </tr>
 ))}
 </tbody>
 </table>
 </Panel>
 </div>
 );
}

export function AdminMessages() {
 const [rows, setRows] = useState([]);
 useEffect(() => { (async () => { const { data } = await api.get('/admin/contact-messages'); setRows(data.messages || []); })(); }, []);
 return (
 <div className="space-y-3">
 {rows.map(r => (
 <Panel key={r.id} className="p-4">
 <div className="h-eyebrow">{(r.created_at || '').slice(0,16).replace('T',' ')}</div>
 <div className="h-serif text-lg" style={{ color: 'var(--heritage-plum)' }}>{r.subject || 'No subject'}</div>
 <div className="text-sm opacity-80" style={{ color: 'var(--heritage-plum)' }}>{r.name}. {r.email}</div>
 <p className="text-sm mt-2" style={{ color: 'var(--heritage-plum)' }}>{r.message}</p>
 </Panel>
 ))}
 {rows.length === 0 && <div className="text-sm opacity-70" style={{ color: 'var(--heritage-plum)' }}>No messages yet.</div>}
 </div>
 );
}

export function AdminReports() {
 const [d, setD] = useState({ signups_by_day: [] });
 useEffect(() => { (async () => { const { data } = await api.get('/admin/reports'); setD(data); })(); }, []);
 const max = Math.max(1, ...d.signups_by_day.map(x => x.count));
 return (
 <Panel className="p-6">
 <div className="h-eyebrow mb-3">Signups by day</div>
 <div className="flex items-end gap-2 h-40">
 {d.signups_by_day.map(x => (
 <div key={x.date} className="flex flex-col items-center gap-1">
 <div className="w-8 rounded-t" style={{ background: 'var(--heritage-plum)', height: `${(x.count / max) * 100}%` }} />
 <div className="h-eyebrow text-[10px]">{x.date.slice(5)}</div>
 </div>
 ))}
 {d.signups_by_day.length === 0 && <div className="text-sm opacity-70" style={{ color: 'var(--heritage-plum)' }}>No signups yet.</div>}
 </div>
 </Panel>
 );
}
